import React from 'react';

const MyPlaylists = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-[#4AE9EC] mb-4">My Playlists</h1>
      <div className="bg-[#0A1330] p-8 rounded-lg">
        <p className="text-[#AEB9E1]">My playlists content will go here.</p>
      </div>
    </div>
  );
};

export default MyPlaylists;